/* unplugin-vue-components disabled */import { render } from "./send-button.vue?vue&type=template&id=03bce7dc&scoped=true"
import script from "./send-button.vue?vue&type=script&lang=js"
export * from "./send-button.vue?vue&type=script&lang=js"

import "./send-button.vue?vue&type=style&index=0&id=03bce7dc&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bce7dc"],['__file',"src/components/chat-input-v2/send-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03bce7dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03bce7dc', __exports__)) {
    api.reload('03bce7dc', __exports__)
  }
  
  module.hot.accept("./send-button.vue?vue&type=template&id=03bce7dc&scoped=true", () => {
    api.rerender('03bce7dc', render)
  })

}


export default __exports__